export const REJET_COORDONNEES_INEXPLOITABLE = 'Coordonnées bancaires inexploitables';
export const REJET_COMPTE_CLOTURE = 'Compte clôturé';
export const REJET_PROVISION_INSUFFISANTE = 'Provision insuffisante';
export const REJET_OPPOSITION_COMPTE = 'Opposition sur compte';
export const REJET_COMPTE_BLOQUE = 'Compte bloqué';
export const REJET_TITULAIRE_DECEDE = 'Titulaire décédé';
export const REJET_AUTRE = 'Autre motif';
